import { useContext } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { AppContext } from "../../../contexts/AppContext";
import { LoadingContent } from "../Shared/LoadingContent";

export type AltRoute = {
    UrlPartial: string
}

/// Makes sure that the user is not authenticated to render its child content, if the user is authenticated the page redirects to the provided url partial
/// See ProtectedRoute for opposite
export const AnonRoute = (props: React.PropsWithChildren<AltRoute>) => {
    const app = useContext(AppContext);

    const [queryParameters] = useSearchParams();
    let id = queryParameters.get("id");
    let s = queryParameters.get("s");

    if (!app.loading && app.userLoggedIn) {
        // user is authenticated
        return <Navigate to={props.UrlPartial != null ? `${props.UrlPartial}${id != null || s != null ? (`?id=${id}`) : ''}${s != null ? (`&s=${s}`) : ''}` : "/"} />;
    }

    return (<>
        <LoadingContent loading={app.loading} classes="w-100">
            {!app.loading && app.userLoggedIn ? null
                :
                <>
                    {props.children}
                </>}
        </LoadingContent>
    </>);
}